module.exports = __webpack_public_path__ + "img/igivethanks.6e458f67.png";